import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { useTranslation } from '../i18n';
export function PricingTeaser() {
  const {
    t
  } = useTranslation();
  return <section id="pricing" className="py-24 bg-[#050505] relative z-20" data-id="element-255">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-256">
        <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-257">
          {t('pricingTeaser.title')}
        </h2>
        <p className="text-white/60 text-lg leading-relaxed mb-12 max-w-2xl mx-auto" data-id="element-258">
          {t('pricingTeaser.desc')}
        </p>
        <Link to="/pricing" className="bg-gradient-animated rounded-full px-10 py-4 text-base font-semibold text-white hover:scale-105 transition-transform duration-300 shadow-[0_0_30px_rgba(123,47,255,0.3)] inline-flex items-center gap-2" data-id="element-259">
          {t('pricingTeaser.cta')}
          <ArrowRightIcon className="w-4 h-4" data-id="element-260" />
        </Link>
      </div>
    </section>;
}